import { render, staticRenderFns } from "./QueueAdmin.vue?vue&type=template&id=83138e62&scoped=true"
import script from "./QueueAdmin.vue?vue&type=script&lang=js"
export * from "./QueueAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83138e62",
  null
  
)

export default component.exports